import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForCycleCounts extends RoutePathBuilder {
    queue() {
        return this.url('');
    }

    perform() {
        return this.url('perform');
    }
}
